/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import * as user from '../../../redux/actions/userAction';
import Datetime from 'react-datetime';
import countryList from '../../../common/country-list.json';
import Select from 'react-select';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from 'yup';
import { Common } from '../../../common/common';
import { config, validateForm, APP_FLOW, DATE_FORMAT_REGEX, AWS_REGION } from '../../../common/constant';
import { EnrollService } from '../../../jwt/_services/enrollment-service';
import { COMPANY_NAME_FULL, GET_PARENT, WAKAF_COMPANY_NAME_FULL } from '../../../common';
import DonationEReceipt from './donation-e-receipt';
import AccountSuccess from './account-success';
import AdoptError from './adopt-error';
import Loader from '../../MUIS/loader';
import { CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { GoogleApiWrapper } from 'google-maps-react';
import { GOOGLE_API_KEY_AUTOCOMPLETE } from '../../../../src/common/constant';
import { selectedStyles } from "../../../common";
import { getAppFlow } from '../../utils/app.utils';
import { AccountContext } from '../../../aws-pool/Account';
import Pool from '../../../aws-pool/login-pool';
import moment from 'moment';
import { withTranslation } from "react-i18next";
import SearchPostalCode from './search-postalcode';
import 'react-datetime/css/react-datetime.css';
import i18n from "i18next";
import { Auth, Amplify } from 'aws-amplify';
import { ARROW_BACK, CLOSE_RED, ICON_CALENDAR, ICON_FACEBOOK_F, ICON_GOOGLE_G, MARK_EXCLAMATION, MARK_EXCLAMATION_17x17, TICK_CIRCLE_BIG } from '../../../common/images-s3';
import { profile } from '../../../jwt/_services/profile-service';
import Footer from '../../../section/footer/footer';
import { PaymentMethodHeader } from '../../../component/skip-enollment';


const ImageLoader = lazy(() => import('../../../common/image-loader'));

function isValidDate(date) {
    let dummyDate = date;
    let seperator = '/';
    // let msg = '';
    let isValid = true;

    if ((/[^\d|\/]/gi).test(dummyDate)) { // invalid characters.
        // msg = 'invalid characters';
        isValid = false;
    }

    let [dd, mm, yyyy] = dummyDate.split(seperator);

    if (!dd || dd.length !== 2 || !parseInt(dd) || parseInt(dd) > 31) {
        // msg = 'invalid date';
        isValid = false;
    } else if (!mm || mm.length !== 2 || !parseInt(mm) || parseInt(mm) > 12) {
        // msg = 'invalid month';
        isValid = false;
    } else if (!yyyy || yyyy.length !== 4 || !parseInt(yyyy)) {
        // msg = 'invalid year';
        isValid = false;
    }

    return isValid;
}

export const validateName = (value, isWakaf, isOnbehalfName) => {
    if (!value) return false;

    const {
        ALLOWED_CHARACTERS,
        ALLOWED_CHARACTERS_WITH_SLASH,
        CONTACT_PERSON,
        CONTACT_PERSON_WITH_SLASH
    } = config.REGEX;

    const allowedCharactersRegex = isWakaf
        ? (isOnbehalfName ? ALLOWED_CHARACTERS_WITH_SLASH : CONTACT_PERSON_WITH_SLASH)
        : (isOnbehalfName ? ALLOWED_CHARACTERS : CONTACT_PERSON);

    const trimmedValue = value.trim();

    const hasInvalidSlashes =
        trimmedValue.startsWith('/') ||
        trimmedValue.endsWith('/') ||
        trimmedValue === '/';

    const hasInvalidCharacters = !allowedCharactersRegex.test(value);

    return hasInvalidSlashes || hasInvalidCharacters;
};


const camelCaseTextConversion = (text) => {
    return text?.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

class EnrollIndividual extends React.Component {
    static contextType = AccountContext;
    formikRef = React.createRef();


    constructor(props) {
        super(props);
        const userData = Common.isValidField(this.props.user.userData) ? this.props.user.userData : {}
        console.log(userData, 'userData', this.props.user)
        // splits phone number in ["+xx", "xxxx xxxx xx"] or ["xxxx xxxx xx"] or [""]
        let phoneNumber = Common.isValidField(userData.phoneNumber)
            ? userData.phoneNumber.split(/^(\+)+(?:\S+)/)
            : Common.isValidField(userData.mobile)
                ? userData.mobile.split(/^(\+)+(?:\S+)/)
                : [''];

        phoneNumber = phoneNumber.length > 1 ? phoneNumber[phoneNumber.length - 1] : phoneNumber[0];

        this.appFlow = getAppFlow();
        const scope = this;
        this.state = {
            registerd_address_combined: '',
            transactionNo: this.props.user.transactionNo ?? '',
            userId: this.props.user.userData.userId ?? '',
            errorMessage: '',
            userData: userData,
            countryDialCode: Common.isValidField(userData.countryCode) ? userData.countryCode : '+65',
            isShowDonationReceipt: false,
            isSingupError: false,
            countryList: countryList.map((item, key) => {
                return { value: key, label: item.name }
            }),
            countryCodeList: countryList.sort((a, b) => a.name.localeCompare(b.name)).map((item, key) => {
                return { value: item.dial_code + ', ' + item.name + ', ' + item.length, label: <div className="div-option"><span className="name countryName"> {item.name}</span><span className="code">{item.dial_code}</span></div> }
            }),
            address: '',
            pincode: this.props.user.userData.pincode ?? "",
            blockNumber: '',
            initialValues: {
                fullname: userData.name || userData.fullname || userData.fullName || '',
                termsConditions: false,
                isOnBehalfOf: this.props.user.isOthers ? true : false,
                onbehalfof: this.props.user.isOthers ? userData.onbehalfof : '',
                mobile: Common.isValidField(phoneNumber) ? phoneNumber?.trim() : '',
                email: userData.email ?? '',
                address: '',
                nric: userData.nric ?? '',
                iAgree: true,
                isReserved: false,
                dateofbirth: userData.dateofbirth,
                streetandpostal: '',
                registeredAddress: scope.getRegisteredAddress(),
                password: '',
                confirmPassword: '',
                buildingName: '',
                blockNumber: '',
                floorNo: '',
                unitNo: '',
            },
            secondaryAccountPayload: {},
            popupDetails: {
                "popupHeading": 'errorMessage',
                "userEmail": "",
                "popupSubHeading": "Please login to the website to get Donation tax deduction and Receipt",
                "isButtonVisible": true,
                "isLoginButton": false,
                "buttonText": "Login to Web"
            },
            isShowEnrollForm: true,
            isLoading: false,
            enrolUserData: [],
            isAnonymousDisabled: false,
            passwordError: '',
            errors: {},
            emailExists: "",
            mobileExists: "",
            nricExists: "",
            multipleAccountExists: '',
            isPanelSecondaryUserCollapse: false,
            isSubmitDisabled: userData.fullName !== '' && userData.email !== '' ? false : true,
            singPassErrorMessage: null,
            isAdoptError: false,
            adoptErrorMsg: '',
            isGoogleSignedIn: false,
            isFacebookSignedIn: false,
            googleMessage: 'You have just signed in via Google',
            facebookMessage: 'You have just signed in via Facebook',
            disableDataFields: false,
            dateofbirth: this.props.user.userData.dateofbirth,
            signUpError: {
                type: '',
                message: ''
            },
            isSignedIn: false,
            // password
            showPassword: false,
            showConfirmPassword: false,


            // errors
            isUserNotConfirmed: false,

            // creds
            username: '',
            password: '',

            isVerificationLinkSent: false,

            currentUser: Pool.getCurrentUser(),
            isMobileNotEmpty: Common.isValidField(phoneNumber?.trim()),
            errorDOB: [],
            addressObj: userData.addressObj ? userData.addressObj : {
                "postalCode": "",
                "blockNumber": "",
                "streetName": "",
                "buildingName": "",
                "country": "",
                "unitNo": "",
                "floorNo": "",
            },
            isEmailRegistered: false,
        }

        this.refEnrollForm = React.createRef();
        this.refMobileField = React.createRef();
        this.refCountryCode = React.createRef();
        this.refMobile = React.createRef();
        this.refDateOfBirth = React.createRef();

        this.enrollView = this.enrollView.bind(this);
        this.closePopUP = this.closePopUP.bind(this);
        this.handletext = this.handletext.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.handleMenuClose = this.handleMenuClose.bind(this);
        this.closeNotification = this.closeNotification.bind(this);
        this.getCountryDialCode = this.getCountryDialCode.bind(this);
        this.onBlurShowSelected = this.onBlurShowSelected.bind(this);
        this.onFocusShowSelected = this.onFocusShowSelected.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleSkip = this.handleSkip.bind(this);
        this.isWakaf = (this.appFlow === APP_FLOW.ILMU || this.appFlow === APP_FLOW.WMS)
    }

    handleDatePickerIsOpen() {
        document.getElementById('trackdate')?.focus()
    }

    handleMenuClose() {
        document.activeElement.blur();
    }



    enrollView(isError) {
        if (isError) {
            this.setState({
                isAdoptError: true,
                isShowEnrollForm: false,
                isLoading: false
            })
        } else {
            this.setState({
                isAdoptError: false,
                isShowEnrollForm: true,
            })
        }
    }

    closeNotification() {
        this.setState({ singPassErrorMessage: null });
    }

    handletext(e) {
        if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
        }

        else {
            let data = e.target.value;
            let val = data.replace(/[^\d]/g, '').replace(/(.{4})/g, '$1 ').trim();
            e.target.value = val
        }
    }

    closePopUP() {
        this.setState({
            isSingupError: false
        })
    }

    onFocusShowSelected(e) {
        if (GET_PARENT(document.activeElement, null, 'select-form-control')?.id === this.refCountryCode.current.props?.id || document.activeElement === this.refMobile.current) {
            this.refMobileField.current.classList.add('focus');
        }
        setTimeout(() => {
            let ele = this.refMobileField.current;
            let menu = ele.querySelector('div[class$="-menu"]');
            if (menu) {
                menu.style.width = ele.offsetWidth + 'px';
                menu.style.opacity = 1;
            }
        }, 500);
    }

    onBlurShowSelected(e) {
        if (GET_PARENT(document.activeElement, null, 'select-form-control')?.id !== this.refCountryCode.current.props?.id && document.activeElement !== this.refMobile.current) {
            this.refMobileField.current.classList.remove('focus');
        }

        if (document.getElementsByClassName('countryName')[0]) {
            document.getElementsByClassName('countryName')[0].style.display = 'none';
        }
        this.setState({ isMobileNotEmpty: Common.isValidField(e?.target.value) });
    }

    getCountryDialCode(e) {
        let countryCode = e.value;

        this.setState({
            countryDialCode: countryCode.split(",")[0],
        })
        document.getElementsByClassName('countryName')[0].style.display = 'none';
        document.activeElement.blur();
        this.onBlurShowSelected()
    }

    updateKeyName = (obj, oldKey, newKey) => {
        const { [oldKey]: oldKeyValue, ...rest } = obj;
        return {
            ...rest,
            [newKey]: oldKeyValue
        };
    }

    donationEnrollment(payload) {
        this.setState({
            emailExists: "",
            mobileExists: "",
            nricExists: "",
            multipleAccountExists: ''
        })
        // for pledge mannually all payload are same except transactionNumber key name
        const pledgePayload = this.updateKeyName(payload, 'transactionNumber', 'pledgeNumber')
        console.log(payload, 'payloadd')
        console.log(pledgePayload, 'pledgepayload')
    }

 
    resetAddressFields = () => {
        this.setState({
            addressObj: {
                "postalCode": "",
                "blockNumber": "",
                "streetName": "",
                "buildingName": "",
                "country": "",
                "unitNo": "",
                "floorNo": "",
            }
        })
    }

    getRegisteredAddress = () => {
        const e = this.props.user.userData.addressObj
        let unit = `${e?.floorNo ? e?.floorNo + "-" : ""}${e?.unitNo ? e?.unitNo : ""}`.trim()
        if (config.REGEX.UNIT_NUMBER.test(unit)) {
            unit = `#${unit}`
        } else if (unit === "-" || unit === "00") {
            unit = ""
        }
        const address = `${e?.blockNumber ? e?.blockNumber : ""} ${e?.streetName ? e?.streetName + " " : ""}${unit ? unit + " " : ""}${e?.buildingName ? e?.buildingName + " " : ""}${e?.country ? e?.country : ""
            } ${e?.postalCode ? e?.postalCode : ""}`.trim();
        return address ? address : ""
    }

    componentDidMount() {
        // Configure Amplify auth with current redirect url
        Amplify.configure({
            Auth: {
                userPoolId: config.AWS_COGNITO_LOGIN_POOL.USER_POOL_ID, //UserPool ID
                region: AWS_REGION,
                userPoolWebClientId: config.AWS_COGNITO_LOGIN_POOL.CLIENT_ID, //WebClientId
                scope: ['phone', 'openid', 'profile', 'email', 'aws.cognito.signin.user.admin'],
                oauth: {
                    domain: config.OAUTH_DOMAIN,
                    redirectSignIn: String(window.location.origin + window.location.pathname),
                    redirectSignOut: String(window.location.origin + window.location.pathname),
                    responseType: 'token'
                }
            }
        });

        this.props?.error?.length > 0 && this.setState({ singPassErrorMessage: true });
        this.props.dispatch(user.updateUserData({ ...this.props.user.userData, isOnEnroll: true }))

        this.setState({
            registerd_address_combined: `${this.state.address} ${this.state.userData.streetandpostal}`
        });

        this.appFlow = getAppFlow();

        const currentUser = Pool.getCurrentUser();


        currentUser && this.setState({ disableDataFields: true, isSignedIn: true });

        if (Common.isValidField(this.state.userData.name)) {
            this.setState({
                isSubmitDisabled: false,
                isAnonymousDisabled: this.state.userData.isAnonymous
            })
        }
        if (document.getElementsByClassName('countryName')[0]) {
            document.getElementsByClassName('countryName')[0].style.display = 'none';
        }

        Common.scrollToTop();
        this.state.initialValues?.email && this.checkUserExistsByEmail(this.state.initialValues?.email);
    }

    shouldComponentUpdate(newProps, newState) {
        const user = Pool.getCurrentUser();

        const nric = this.props.user.userData.nric;
        const uen = this.props.user.userData.uen;

        const nric1 = newProps.user.userData.nric;
        const uen1 = newProps.user.userData.uen;

        if (!Boolean(nric || uen) && Boolean(nric1 || uen1)) {
            const userData = Common.isValidField(newProps.user.userData) ? newProps.user.userData : {}

            let phoneNumber = Common.isValidField(userData.phoneNumber)
                ? userData.phoneNumber.split(/^(\+)+(?:\S+)/)
                : Common.isValidField(userData.mobile)
                    ? userData.mobile.split(/^(\+)+(?:\S+)/)
                    : [''];

            phoneNumber = phoneNumber.length > 1 ? phoneNumber[phoneNumber.length - 1] : phoneNumber[0];
            this.refEnrollForm.current.setValues({
                fullname: userData.name || userData.fullname || userData.fullName || '',
                onbehalfof: userData.onbehalfof ?? '',
                mobile: Common.isValidField(phoneNumber) ? phoneNumber?.trim() : '',
                email: userData.email ?? '',
                address: '',
                unitNo: '',
                floorNo: '',
                blockNumber: '',
                nric: userData.nric ?? '',
                iAgree: true,
                isReserved: false,
                dateofbirth: userData.dateofbirth || this.refEnrollForm.current.values.dateofbirth,
                streetandpostal: '',
                password: '',
                confirmPassword: '',
                registeredAddress: this.getRegisteredAddress() ?? '',
            });

            this.setState({ currentUser: user, disableDataFields: user ? true : false });
        }

        return true;
    }

    componentDidUpdate() {
        if (document.getElementsByClassName('countryName')[0]) {
            if (document.getElementsByClassName('countryName')[0].style.display !== 'none') {
                document.getElementsByClassName('countryName')[0].style.display = 'none';
            }
        }
        if (!this.state.isCreateAccount && this.props.user.userData?.accountCreated) {
            this.setState({ isCreateAccount: this.props.user.userData?.accountCreated })
        }

    }

    handleNext() {
        if (this.refEnrollForm.current) {
            this.refEnrollForm.current.submitForm();
          }
          this.props.setHeaderData(PaymentMethodHeader)
          this.props.dispatch(user.updateUserSteps(PaymentMethodHeader));

    }
    handleSkip()
    {

    }

    onFormSubmit(values) {
        console.log(values, 'valuesss')
        // Need to get transactionNo from payNow API response
        values.fullname = values.fullname.trim().replace(/\s\s+/g, ' ')
        values.unitNo = Common.isValidField(this.state.address) ? String(this.state.address).replace(/\s\s+/g, ' ') : "";
        values.streetandpostal = Common.isValidField(this.state.streetandpostal) ? String(this.state.streetandpostal).replace(/\s\s+/g, ' ') : "";
        values.email = values.email.replace(/\s\s+/g, ' ');
        values.onbehalfof = values.onbehalfof.replace(/\s\s+/g, ' ');

        this.setState({
            isLoading: true,
            initialValues: values
        })

        let receiptData = {
            "userEmail": values.email,
            "userMobile": values.mobile
        }

        const addressObj = {
            ...this.state.addressObj,
            "unitNo": values.unitNo || this.state.addressObj.unitNo || "",
            "floorNo": values.floorNo || this.state.addressObj.floorNo || "",
            blockNumber: values.blockNumber || this.state.addressObj.blockNumber || "",
        };

        console.log(addressObj, 'adbob')

        this.setState({ receiptData: receiptData })

        let enrollPayload = {
            "name": values.fullname,
            "email": values.email,
            "phoneNumber": values.mobile.trim().length ? this.state.countryDialCode + ' ' + values.mobile.replace(/\s/g, '') : '',
            // "registeredAddress": !values.registeredAddress ? (values.address ? values.address + ', ' + values.streetandpostal : values.streetandpostal || '').trim() : values.registeredAddress,
            "onBehalfOf": values.onbehalfof,
            "nric": values.nric,
            "transactionNumber": this.state.transactionNo,
            "charityId": (this.appFlow === APP_FLOW.ILMU || this.appFlow === APP_FLOW.WMS) ? this.props?.homepage?.charityId : config.MUIS_CHARITY_ID,
            "iAgree": values.iAgree,
            "isCreateAccount": this.state.isCreateAccount,
            "dateOfBirth": values.dateofbirth,
            ...addressObj,
        }

        console.log(enrollPayload, 'enrollPayload')

        const flow = {
            name: values.fullname,
            flow: config.FLOW.MANUALLY,
            countryCode: this.state.countryDialCode,
            mobile: values.mobile,
            pincode: this.state.pincode,
            accountCreated: this.state.isCreateAccount,
            uen: this.state.userData.uen,
            registeredAddress: !values.registeredAddress ? (values.unitNo ? values.unitNo + ', ' + values.streetandpostal : values.streetandpostal || '').trim() : values.registeredAddress,
            addressObj: addressObj,
        };


        // remove password and confirm password
        delete values['password'];
        delete values['confirmPassword'];

      
            this.props.dispatch(user.updateUserData({
                ...this.state.userData,
                ...values,
                ...flow,
                mobile: values.mobile ? this.state.countryDialCode + ' ' + values.mobile : '',
            }));

            this.donationEnrollment(enrollPayload);
        

    }

    handleChangeAddress = (address, setField) => {
        setField('streetandpostal', address);
        this.setState({ streetandpostal: address })
    }

    handleSelectAddress = (address, setField) => {
        address = address.split(this.state.pincode).join('');

        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(latLng => {
                EnrollService.getPostalCodeFromGoogleAPI(latLng.lat, latLng.lng)
                    .then(results => {
                        const postalCode = results.address_components[results.address_components.length - 1].short_name;

                        this.setState({ streetandpostal: address + ' ' + postalCode, pincode: postalCode },
                            () => setField('streetandpostal', this.state.streetandpostal));

                    })
            })
            .catch(error => console.error('Error', error));
    };

    handleAddressErrors = (status, clearSuggestions, setFieldError) => {
        clearSuggestions();
    }

    responseGoogle = (response) => {
        let initialValues = { ...this.state.initialValues }
        initialValues.fullname = response.name
        initialValues.email = response.email;

        let nric = document.getElementById("nric").value.trim()

        const isValidNRIC = nric !== "" ? String(nric).match(config.REGEX.NRIC) : false;

        this.setState({
            initialValues,
            isGoogleSignedIn: true,
            isSubmitDisabled: (this.props.user.hasIRASInclusion ? isValidNRIC : false)
        })
    }

    responseFailureGoogle = (response) => {
        this.setState({ isGoogleSignedIn: false })
    }

    componentClicked = (data) => {
        console.warn(data)
    }

    responseFacebook = (response) => {
        let initialValues = { ...this.state.initialValues }
        initialValues.fullname = response.name
        initialValues.email = response.email

        let nric = document.getElementById("nric").value.trim()

        const isValidNRIC = nric !== "" ? String(nric).match(config.REGEX.NRIC) : false;

        if (response.accessToken) {
            this.setState({
                initialValues,
                isFacebookSignedIn: true,
                isSubmitDisabled: (this.props.user.hasIRASInclusion ? isValidNRIC : false)
            })
        } else {
            this.setState({ initialValues, isFacebookSignedIn: false })
        }
    }


    handleSelectDOB = (dateStr) => {
        this.setState({ dateofbirth: dateStr })
    }

    showPassword = ({ name }) => {
        switch (name) {
            case "password": {
                this.setState({
                    showPassword: !this.state.showPassword,
                });
                break;
            }
            case "confirmPassword": {
                this.setState({
                    showConfirmPassword: !this.state.showConfirmPassword,
                });
                break;
            }
            default:
                break;
        }
    }


    // Postal code API
    handleAddressChange = (address, postalCode, e) => {
        const addressObj = {
            ...e,
            streetName: camelCaseTextConversion(e?.streetName),
            buildingName: camelCaseTextConversion(e?.buildingName),
            country: e?.countryCode === "SG" ? "Singapore" : "",
        }
        delete addressObj['countryCode'];
        this.setState({ streetandpostal: address.toUpperCase(), pincode: postalCode, addressObj: addressObj, blockNumber: e?.blockNumber }, () => {
            // Code to execute after state has been updated
            this.forceUpdate();
        })
    }

    isWithinLast100Years(dateString) {
        // Use Moment.js to parse the date string
        const date = moment(dateString, 'DD/MM/YYYY', true);

        // Check if the date is valid
        if (!date.isValid()) {
            return false;
        }

        // Calculate the difference between the date and today
        const diff = moment().diff(date, 'years');

        // Return true if the date is within the last 100 years
        return diff <= 100;
    }

    checkUserExistsByEmail = (email) => {
        if (config.REGEX.EMAIL_ADDRESS.test(email) === false) return;
        profile.checkUserExistsByEmail(email)
            .then((res) => {
                this.setState({
                    isEmailRegistered: res.data?.isEmailExists,
                    // isCreateAccount: res.data?.isEmailExists ? false : this.state.isCreateAccount
                })
                this.appFlow = getAppFlow();

            }

            )

    }

    render() {


        const { t } = this.props;

        return (
            <>
                {this.state.isLoading ? <div className="enroll-confirm-loader site-loader"><Loader /></div> : null}

                {this.state.isShowEnrollForm ?
                    <Formik
                        enableReinitialize={true}
                        initialValues={this.state.initialValues}
                        validationSchema={
                            Yup.object().shape({
                                email: Yup.string().matches(config.REGEX.EMAIL_ADDRESS, t('ValidateForm_validEmail')).required(t('Enrol_enter_email_address')),
                                onbehalfof: Yup.string().when('isOnBehalfOf', {
                                    // is: true,
                                    is: (isOnBehalfOf) => (isOnBehalfOf && this.appFlow !== APP_FLOW.FIDYAH),
                                    then: Yup.string().required(t('Enrol_on_behalf_of_error')), /* .matches(/(^\s+|\s+$)/g, validateForm.onbehalfOf).matches(/\W|\d/gi,validateForm.onbehalfOf) */
                                    otherwise: Yup.string()
                                }),
                                unitNo: Yup.string().when('streetandpostal', {
                                    is: (streetandpostal) => streetandpostal,
                                    then: Yup.string().required(""),
                                    otherwise: Yup.string()
                                }),
                                floorNo: Yup.string().when('streetandpostal', {
                                    is: (streetandpostal) => streetandpostal,
                                    then: Yup.string().required(""),
                                    otherwise: Yup.string()
                                }),
                            })
                        }
                        onSubmit={this.onFormSubmit}
                        innerRef={this.refEnrollForm}
                        validateOnChange
                        validateOnMount

                        validate={(values, props = this.props) => {
                            let errors = {};
                            const fullName = document.getElementsByName('fullname');
                            const emailId = document.getElementById('email');
                            this.appFlow = getAppFlow()

                            const fullNameInput = fullName[0];
                            const currentFullNameValue = values.fullname;



                            if (!currentFullNameValue.length) {
                                errors.fullname = t('ValidateForm_fullName');
                            } else if (validateName(values.fullname, this.isWakaf, false)) {
                                fullNameInput.classList.add('is-invalid');
                                errors.fullname = t('ValidateForm_fullName');
                            } else {
                                fullNameInput.classList.remove('is-invalid');
                            }

                            if (config.REGEX.EMAIL_ADDRESS.test(emailId.value) === false && values.email.length > 0) {
                                document.getElementById('email').classList.add('is-invalid');
                            } else {
                                document.getElementById('email').classList.remove('is-invalid');
                            }

                            if (values.nric.length > 0 && config.REGEX.NRIC.test(values.nric) === false) {
                                errors.nric = t('ValidateForm_validNric')
                                document.getElementById('nric').classList.add('is-invalid');
                            } else {
                                document.getElementById('nric').classList.remove('is-invalid');
                            }

                            this.setState({
                                emailExists: "",
                                mobileExists: "",
                                nricExists: "",
                                multipleAccountExists: '',
                            });



                            if (!values.dateofbirth) {
                                errors.dateofbirth = t('Individual_please_select_date_of_birth');
                            } else if (!this.isWithinLast100Years(values.dateofbirth)) {
                                errors.dateofbirth = t('Please_select_valid_date_of_birth');
                            } else if (!isValidDate(values.dateofbirth) || moment(values.dateofbirth, 'DD/MM/YYYY') > moment()) {
                                errors.dateofbirth = t('Individual_please_select_date_of_birth');
                            }

                            // if (values.streetandpostal && (values?.blockNumber === "" && this.state.blockNumber === "")) {
                            //     errors.blockNumber = t('Validation_blockNumber');
                            // }


                            values.mobile = values.mobile?.replace(/[^\d]/g, '').replace(/(.{4})/g, '$1 ').trim();

                            if (!values.mobile) {
                                errors.mobile = t('ValidateForm_mobile');
                            } else {
                                let mobno = values.mobile;
                                mobno = mobno.replace(/\s/g, '');
                                if (mobno.length < 8) {
                                    errors.mobile = t('ValidateForm_mobile');
                                } else if (mobno.length > 16) {
                                    errors.mobile = t('ValidateForm_mobile_max');
                                }
                            }

                            if (!values.registeredAddress && props.user.is3DSNeeded && String(values.unitNo).trim() === "") {
                                errors.unitNo = "Please enter House No. / Block / Unit No.";
                            }

                            if (!values.registeredAddress && props.user.is3DSNeeded && String(values.streetandpostal).trim() === "") {
                                errors.streetandpostal = "Please enter Street Name / Postal Code"
                            }

                            if ((this.state.isCreateAccount || props.user.hasIRASInclusion || (origin.includes(config.FLOW.WAKAF) && this.props?.widget?.cause?.donationAmount >= config.WAKAF_ENROLL_MAX_AMOUNT)) && !values.nric) {
                                errors.nric = t('ValidateForm_nric')
                            };



                            if (props.user.isOthers || this.appFlow == APP_FLOW.FIDYAH || this.appFlow == APP_FLOW.ILMU || this.appFlow == APP_FLOW.WMS) {

                                if (values.onbehalfof.trim().length === 0 && this.appFlow !== APP_FLOW.FIDYAH && this.appFlow !== APP_FLOW.ILMU && this.appFlow !== APP_FLOW.WMS) {
                                    errors.onbehalfof = t('Enrol_on_behalf_of_error');
                                    document.getElementById('onbehalfof').classList.remove('is-invalid');
                                } else if (values.onbehalfof.trim().length === 0 && (this.appFlow === APP_FLOW.FIDYAH || this.appFlow === APP_FLOW.ILMU || this.appFlow === APP_FLOW.WMS)) {
                                    document.getElementById('onbehalfof').classList.remove('is-invalid');
                                } else if (String(values.onbehalfof).match(/^\s+/g)) { /* (^\s+|\s+$)/g) */
                                    errors.onbehalfof = t('Enrol_on_behalf_of_error');
                                    document.getElementById('onbehalfof').classList.add('is-invalid');
                                } else if (validateName(values.onbehalfof, this.isWakaf, true)) {
                                    document.getElementById('onbehalfof').classList.add('is-invalid');
                                    errors.onbehalfof = t('Enrol_on_behalf_of_error');
                                } else if (values.onbehalfof.trim().length > ((this.appFlow === APP_FLOW.ZAKAT || this.appFlow === APP_FLOW.FIDYAH) ? 500 : 200)) {
                                    document.getElementById('onbehalfof').classList.add('is-invalid');
                                    errors.onbehalfof = t('Enrol_on_behalf_of_error');
                                } else {
                                    const onBehalfOf = String(values.onbehalfof)?.trim().split(/\s+/gim);

                                    const restrictedWords = onBehalfOf.some(
                                        (word) =>
                                            word.toLowerCase() === "hamba allah" ||
                                            word.toLowerCase() === "hamba" ||
                                            word.toLowerCase() === "hambaallah" ||
                                            word.toLowerCase() === "anonymous"
                                    );

                                    if (restrictedWords) {
                                        errors.onbehalfof = t('Enrol_on_behalf_of_error');
                                        document.getElementById('onbehalfof').classList.add('is-invalid');
                                    } else {
                                        document.getElementById('onbehalfof').classList.remove('is-invalid');
                                    }
                                }
                            }

                            i18n.on("languageChanged", () => {
                                if (document.getElementById('fullname')) {
                                    document.getElementById('fullname').focus();
                                    setTimeout(() => document.getElementById('fullname').blur(), 10);
                                }
                                if (this.state.errorDOB.length) {
                                    // console.log('state.errorDOB',this.state.errorDOB,t(this.state.errorDOB[1]));
                                    this.setState({ errorDOB: [t(this.state.errorDOB[1]), this.state.errorDOB[0]] });
                                }
                            });

                            return errors;
                        }}>
                        {({ errors, touched, isValid, dirty, values, handleChange, setFieldValue, setFieldTouched, setFieldError }) => {
                            return (
                                <Form className="form">
                                    {/* arrow-back-red */}
                                    <div className="sec-enroll individual">

                                        <div className="row">
                                            <div className="col-md-6 form-group">
                                                <label className="cust-label">{t('Enrol_full_name')} <span className='star'>*</span></label>
                                                <Field
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t('Enrol_enter_full_name')}
                                                    id="fullname"
                                                    name="fullname"
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        setFieldValue('fullname', Common.trimExtraSpacesRemoveHTML(e.target.value.toUpperCase()));
                                                    }}
                                                // disabled={this.state.disableDataFields}
                                                />
                                                {touched.fullname && errors.fullname ?
                                                    <span className="invalid-feedback">{errors.fullname}</span>
                                                    : null
                                                }
                                                {/* <ErrorMessage name='fullname'>{msg => <span className="invalid-feedback" name="fullname">{t('ValidateForm_fullName')}</span>}</ErrorMessage> */}
                                            </div>
                                            <div className="col-md-6 form-group c-nric-fin">
                                                <label className="cust-label">{t('Enrol_nric_fin')}&nbsp;
                                                    {(this.state.isCreateAccount || (
                                                        (this.appFlow !== APP_FLOW.FIDYAH) &&
                                                        this.props.user.hasIRASInclusion
                                                    ) || (origin.includes(config.FLOW.WAKAF) && this.props?.widget?.cause?.donationAmount >= config.WAKAF_ENROLL_MAX_AMOUNT)) ? <span className='star'>*</span> : null
                                                    }</label>
                                                <Field
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t('Enrol_enter_nric_fin')}
                                                    name="nric"
                                                    id="nric"
                                                    disabled={this.state.disableDataFields && this.state.initialValues.nric}
                                                    onChange={(ev) => {
                                                        handleChange(ev);
                                                        setFieldValue("nric", ev.target.value.toUpperCase());
                                                        this.setState({ nric: ev.target.value.toUpperCase() });
                                                    }}
                                                    data-sentry-mask
                                                />
                                                {touched.nric && errors.nric ?
                                                    <span className="invalid-feedback">{errors.nric}</span>
                                                    : null
                                                }
                                                {this.state.nricExists !== '' ? <span className="invalid-feedback">{this.state.nricExists}</span> : ''}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className={"col-md-6 form-group " + (this.props.user.isOthers || this.appFlow == APP_FLOW.FIDYAH ? '' : 'hide')}>
                                                <label className="cust-label">{t('Enrol_on_behalf_of')}&nbsp;{this.appFlow === APP_FLOW.FIDYAH ? "" : <span className='star'>*</span>}</label>
                                                <Field
                                                    type="text"
                                                    id="onbehalfof"
                                                    name="onbehalfof"
                                                    className="form-control"
                                                    placeholder={t('Enrol_enter_name')} /* validate={this.validateOnBehalfOf} */ /* onChange={()=>validateField('onbehalfof')} */
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        const value = e.target.value.toUpperCase();
                                                        setFieldValue('onbehalfof', Common.trimExtraSpacesRemoveHTML(value));
                                                    }}
                                                />
                                                {touched.onbehalfof && errors.onbehalfof ?
                                                    <span className="invalid-feedback">{errors.onbehalfof}</span>
                                                    : null
                                                }
                                                {
                                                    values.onbehalfof && <span className="onbehalf-notes">{t('Enrol_onbehalfof_text')}</span>
                                                }
                                            </div>
                                            <div className="col-md-6 form-group c-date">
                                                <label className="cust-label">{t('Enrol_date_of_birth')}&nbsp;<span className='star'>*</span></label>
                                                <Datetime
                                                    name="dateofbirth"
                                                    id="dateofbirth"
                                                    locale="en-es"
                                                    dateFormat="DD/MM/YYYY"
                                                    ref={this.refDateOfBirth} 
                                                    timeFormat={false}
                                                    inputProps={{
                                                        placeholder: t('Enrol_dob_format'),
                                                        /* readOnly: "readonly", */
                                                        className: `form-control date-field ${this.state.errorDOB.length ? 'is-invalid' : ''}`,
                                                        id: "trackdate",
                                                        autoComplete: 'off',
                                                        autoCorrect: 'off',
                                                        spellCheck: 'false'
                                                    }}
                                                    closeOnSelect={true}
                                                    value={values.dateofbirth}
                                                    isValidDate={(date) => moment().isSameOrAfter(date)}
                                                    onClose={() => {
                                                        if (!values.dateofbirth) {
                                                            setFieldTouched("dateofbirth", true);
                                                        }
                                                    }}
                                                    initialValue={values.dateofbirth}
                                                    onChange={(date) => {
                                                        let dateStr = null;

                                                        if (date instanceof Object) {
                                                            const dateView =
                                                                this.refDateOfBirth.current.state.viewDate
                                                                    ? moment(this.refDateOfBirth.current.state.viewDate)
                                                                    : moment();

                                                            if (dateView.daysInMonth() === 30 &&
                                                                dateView.month() > date.month() &&
                                                                date.date() === 1) {
                                                                date.set('date', 31);
                                                            }

                                                            dateStr = date.format('DD/MM/YYYY');

                                                            if (date > moment()) {
                                                                setFieldValue("dateofbirth", dateStr);
                                                                this.setState({ 'errorDOB': [t('Individual_please_select_date_of_birth'), 'Individual_please_select_date_of_birth'] });
                                                            } else {
                                                                setFieldValue("dateofbirth", dateStr);
                                                                if (!this.isWithinLast100Years(dateStr)) {
                                                                    this.setState({ 'errorDOB': [t('Please_select_valid_date_of_birth'), 'Please_select_valid_date_of_birth'] });
                                                                } else {
                                                                    this.handleSelectDOB(dateStr);
                                                                    this.setState({ 'errorDOB': '' });
                                                                }
                                                            }
                                                        } else {

                                                            function checkValue(str, max) {
                                                                if (str.charAt(0) !== '0' || str === '00') {
                                                                    var num = parseInt(str);
                                                                    if (isNaN(num) || num <= 0 || num > max) num = 1;
                                                                    str = num > parseInt(max.toString().charAt(0))
                                                                        && num.toString().length === 1 ? '0' + num : num.toString();
                                                                };
                                                                return str;
                                                            };

                                                            var input = this.refDateOfBirth.current.state.inputValue;
                                                            if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
                                                            var values = input.split('/').map(function (v) {
                                                                return v.replace(/\D/g, '')
                                                            });
                                                            if (values[0]) values[0] = checkValue(values[0], 31);
                                                            if (values[1]) values[1] = checkValue(values[1], 12);
                                                            var output = values.map(function (v, i) {
                                                                return v.length === 2 && i < 2 ? v + ' / ' : v;
                                                            });

                                                            this.refDateOfBirth.current.state.inputValue = output.join('').substr(0, 14);
                                                            const dummy = output.join('').substr(0, 14).replace(/ /g, '');

                                                            if (DATE_FORMAT_REGEX.test(dummy)) {

                                                                const dateObject = dummy.split('/');
                                                                const dt = Number(dateObject[0]);
                                                                const mnth = Number(dateObject[1]);
                                                                const yr = Number(dateObject[2]);

                                                                let isLeap = dt > 28 && mnth === 2;
                                                                let isValid = moment(dateObject, "DD/MM/YYYY").isValid();
                                                                let dateIsPast = moment(dateObject, "DD/MM/YYYY").isBefore();
                                                                const currentYear = moment().year();
                                                                const minYear = currentYear - 100;
                                                                const maxDate = moment(`${minYear}-12-31`, 'YYYY-MM-DD');
                                                                const isWithin100Years = moment(date, 'DD/MM/YYYY').isBetween(maxDate, moment());

                                                                if (isLeap) {
                                                                    isValid = !((yr % 4) || (!(yr % 100) && (yr % 400)));
                                                                }

                                                                if (isValid && dateIsPast && isWithin100Years) {
                                                                    setFieldValue("dateofbirth", dummy);
                                                                    this.handleSelectDOB(dummy);
                                                                    this.setState({ 'errorDOB': [] });
                                                                } else {
                                                                    setFieldValue("dateofbirth", dummy);
                                                                    this.setState({ 'errorDOB': !isWithin100Years ? [t('Please_select_valid_date_of_birth'), 'Please_select_valid_date_of_birth'] : [t('Individual_please_select_date_of_birth'), 'Individual_please_select_date_of_birth'] });
                                                                }
                                                            } else {
                                                                if (dummy) {
                                                                    setFieldValue("dateofbirth", dummy);
                                                                    this.setState({ 'errorDOB': [t('Individual_please_select_date_of_birth'), 'Individual_please_select_date_of_birth'] });
                                                                } else {
                                                                    setFieldValue("dateofbirth", dummy);
                                                                    this.setState({ 'errorDOB': [] });
                                                                }
                                                            }
                                                        }
                                                    }}
                                                />
                                                {this.state.errorDOB.length ? <span className="invalid-feedback">{this.state.errorDOB[0]}</span>
                                                    :
                                                    <ErrorMessage name='dateofbirth'>
                                                        {msg => (
                                                            <span className="invalid-feedback">{msg}</span>
                                                        )}
                                                    </ErrorMessage>}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 form-group c-mobile-number">
                                                <label className="cust-label">{t('Enrol_mobile_number')}&nbsp;<span className='star'>*</span></label>
                                                <div ref={this.refMobileField} className={"c-fields " + (!errors.mobile && this.state.isMobileNotEmpty ? 'selected ' : '')}>
                                                    <Select
                                                        // name="countryCode"
                                                        ref={this.refCountryCode}
                                                        id="countryCode"
                                                        placeholder="+65"
                                                        onChange={this.getCountryDialCode}
                                                        onFocus={(e) => this.onFocusShowSelected(e)}
                                                        onBlur={this.onBlurShowSelected}
                                                        onMenuClose={this.handleMenuClose}
                                                        isDisabled={this.state.disableDataFields}
                                                        styles={selectedStyles}
                                                        className={'select-form-control ' /* + (this.state.countryDialCode.trim() !== '' ? 'focus' : '') */}
                                                        defaultValue={this.state.countryDialCode ? this.state.countryCodeList.filter((option) => option.value.split(",")[0] === this.state.countryDialCode) : ''}
                                                        // defaultValue={this.state.countryDialCode}
                                                        options={this.state.countryCodeList}
                                                        maxMenuHeight={160}
                                                    />
                                                    <div className="v-line"></div>
                                                    <Field
                                                        innerRef={this.refMobile}
                                                        type="tel"
                                                        className="form-control"
                                                        onPaste={(e) => Common.formatNumber(e)}
                                                        placeholder={t('Enrol_enter_mobile_number')}
                                                        onKeyPress={this.handletext}
                                                        onFocus={(e) => {
                                                            // setFieldTouched('mobile',true);
                                                            this.onFocusShowSelected(e)
                                                        }}
                                                        onBlur={(e) => {
                                                            setFieldTouched('mobile', true);
                                                            this.onBlurShowSelected(e)
                                                        }}
                                                        name="mobile"
                                                        id="mobile"
                                                        data-sentry-mask
                                                    />

                                                </div>

                                                {touched.mobile && errors.mobile ? <span className="invalid-feedback">{errors.mobile}</span> : null}
                                                {this.state.mobileExists ? <span className="invalid-feedback">{t('Enrol_mobile_exists_error')}</span> : ''}

                                            </div>
                                            <div className="col-md-6 form-group">
                                                <label className="cust-label">{t('Enrol_email_address')} <span className='star'>*</span></label>

                                                <Field
                                                    id="email"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t('Enrol_email_address')}
                                                    name="email"
                                                    disabled={this.state.disableDataFields}
                                                    onChange={(e) => {
                                                        const value = e.target.value.toUpperCase();
                                                        setFieldValue('email', value)
                                                        // this.checkUserExistsByEmail(e.target.value)
                                                    }}
                                                />
                                                <ErrorMessage name='email'>{msg => <span className="invalid-feedback" name="email">{t('ValidateForm_validEmail')}</span>}</ErrorMessage>
                                                {this.state.emailExists !== '' ? <span className="invalid-feedback">{this.state.emailExists}</span> : ''}
                                            </div>
                                        </div>

                                        {!values.registeredAddress ?
                                            <div className="row">

                                                <div className="col-md-6 form-group c-postal-code">

                                                    <label className="cust-label">{t('Enrol_singapore_postal_code')}&nbsp;{this.props.user.is3DSNeeded && <span className='star'>*</span>}</label>


                                                    <SearchPostalCode handleAddressChange={this.handleAddressChange} setField={setFieldValue} t={t} />

                                                    <ErrorMessage name='streetandpostal'>{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage>
                                                </div>
                                                <div className="col-md-6 form-group">
                                                    <label className="cust-label">{t('Enrol_buildingName')}{/*&nbsp;values.streetandpostal && <span className='star'>*</span>*/}</label>
                                                    <Field 
                                                        type="text" 
                                                        className="form-control"
                                                        maxLength={config.ENROL_MAXLENGTH.BUILDING_NAME}
                                                        placeholder={t('Enrol_enter_buildingName')}
                                                        value={this.state.addressObj.buildingName}
                                                        name="buildingName"
                                                        id="buildingName"
                                                        onChange={(ev) => {
                                                            // const trimmedValue = String(ev.target.value).trim();
                                                            handleChange(ev);
                                                            if (ev.target.value) {
                                                                this.setState(prevState => ({
                                                                    addressObj: {
                                                                      ...prevState.addressObj,
                                                                      buildingName: ev.target.value,
                                                                    }
                                                                  })); 
                                                            } else {
                                                                this.setState(prevState => ({
                                                                    addressObj: {
                                                                      ...prevState.addressObj,
                                                                      buildingName: "",
                                                                    }
                                                                  }));
                                                            }
                                                        }}
                                                    />
                                                    <ErrorMessage name='buildingName'>{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage>
                                                </div>

                                                <div className="col-md-6 form-group">
                                                    <label className="cust-label">{t('Enrol_blockNumber')}&nbsp;{values.streetandpostal && <span className='star'>*</span>}</label>
                                                    <Field 
                                                        type="text" 
                                                        className="form-control"
                                                        maxLength={config.ENROL_MAXLENGTH.BLOCK}
                                                        placeholder={t('Enrol_enter_blockNumber')}
                                                        value={this.state.blockNumber}
                                                        name="blockNumber"
                                                        id="blockNumber"
                                                        onChange={(ev) => {
                                                            const trimmedValue = String(ev.target.value).trim();
                                                            handleChange(ev);
                                                            if (trimmedValue) {
                                                                this.setState({ blockNumber:  trimmedValue });
                                                            } else {
                                                                this.setState({ blockNumber:  '' });
                                                            }
                                                        }}
                                                    />
                                                    <ErrorMessage name='blockNumber'>{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage>
                                                </div>
                                                <div className="col-md-3 form-group c-floor-no">
                                                    <label className="cust-label">{t('Enrol_floorNo')}&nbsp; <span className='c-hash text-black'>#</span>&nbsp;{values.streetandpostal && <span className='star'>*</span>}  </label>
                                                   
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        maxLength={config.ENROL_MAXLENGTH.UNIT_NO}
                                                        placeholder={t('Enrol_enter_floorNo')}
                                                        name="floorNo"
                                                        // value={this.state.floorNo}
                                                        id="floorNo"
                                                        onChange={(ev) => {
                                                            const trimmedValue = String(ev.target.value).trim();
                                                            handleChange(ev);
                                                            if (trimmedValue === "") {
                                                                setFieldError('floorNo', t('Validation_floorNo'));
                                                                this.setState({ floorNo: '' });
                                                            } else {
                                                                setFieldValue("floorNo", trimmedValue);
                                                                this.setState({ floorNo: trimmedValue });
                                                            }
                                                        }}
                                                    />
                                                    <ErrorMessage name='floorNo'>{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage>
                                                    {
                                                        values.streetandpostal && <span className="addrs-note-1">{t('Enrol_info_text')}</span>
                                                    }
                                                </div>
                                                
                                                <div className="col-md-3 form-group mb-0">
                                                    <label className="cust-label">{t('Unit_no')}&nbsp;{values.streetandpostal && <span className='star'>*</span>}</label>
                                                    <Field type="number" className="form-control"
                                                        placeholder={t('Enrol_enter_unit_no')}
                                                        maxLength={config.ENROL_MAXLENGTH.UNIT_NO}
                                                        name="unitNo"
                                                        // value={this.state.addressObj.blockNumber}
                                                        onChange={(ev) => {
                                                            if (ev.target.value === '#') return;
                                                            handleChange(ev);
                                                            if (config.REGEX.HTML.test(String(ev.target.value).trim())) {
                                                                setFieldError('unitNo', 'Please enter valid address');
                                                                this.setState({ address: '' });
                                                            } else {
                                                                setFieldValue("unitNo", ev.target.value.toUpperCase());
                                                                this.setState({ address: ev.target.value.toUpperCase() });
                                                            }
                                                        }} />
                                                    <ErrorMessage name='unitNo'>{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage>
                                                    {
                                                        values.streetandpostal && <span className="addrs-note-1">{t('Enrol_info_text')}</span>
                                                    }
                                                </div>
                                            </div>
                                            :
                                            <div className="row">
                                                <div className="col-lg-12 form-group">
                                                    <label className="cust-label">{t('Enrol_registered_address')}&nbsp;{this.props.user.is3DSNeeded && <span className='star'>*</span>}</label>
                                                    <Field
                                                        id="registeredAddress"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={t('Enrol_enter_registered_address')}
                                                        name="registeredAddress"
                                                        value={values.registeredAddress}
                                                        onChange={(ev) => {
                                                            setFieldValue("unitNo", '');
                                                            setFieldValue("blockNumber", '');
                                                            setFieldValue("floorNo", '');
                                                            setFieldValue("registeredAddress", '');
                                                            setFieldValue("streetandpostal", '');
                                                            this.resetAddressFields();

                                                        }}
                                                    />
                                                    <ErrorMessage name='registerdAddress'>{msg => <span className="invalid-feedback">{msg}</span>}</ErrorMessage>

                                                </div>
                                            </div>
                                        }

                                        <div>
                                            <Footer
                                                isSkipButtonVisible={false}
                                                handleNext={this.handleNext}
                                                handleSkip={this.handleSkip}
                                                disabled={((!isValid && !dirty && this.state.isSubmitDisabled) ||
                                                    (this.state.isCreateAccount && (!this.state.isEmailRegistered))
                                                    ? !(values?.password?.trim().length && values?.confirmPassword?.trim().length)
                                                    : false) || !!Object.keys(errors).length
                                                } />
                                        </div>
                                    </div>
                                </Form>
                            )
                        }}
                    </Formik> : this.state.isAdoptError ? <AdoptError changeView={this.enrollView} adoptErrorMsg={this.state.adoptErrorMsg}> </AdoptError> : this.state.isShowDonationReceipt ? <DonationEReceipt data={this.state.receiptData}>  </DonationEReceipt> : null}
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.userReducer,
        homepage: state.homepageReducer,
        widget: state.donationWidgetReducer
    }
}

export default GoogleApiWrapper({
    apiKey: (GOOGLE_API_KEY_AUTOCOMPLETE)
})(connect(mapStateToProps)(withTranslation()(EnrollIndividual)));